/**
 * @generated SignedSource<<fede2250a28c1036d502c7a0d09fbbf6>>
 * @relayHash 446a6fa3fbbe8bbb4444e858a1c7626c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14

import type { ConcreteRequest } from 'relay-runtime';
export type useMarkCommentsAsReadMutation$variables = {
  commentIds: ReadonlyArray<string>;
};
export type useMarkCommentsAsReadMutation$data = {
  readonly markCommentsAsRead: {
    readonly errors: ReadonlyArray<string | null>;
    readonly success: boolean;
  } | null;
};
export type useMarkCommentsAsReadMutation = {
  response: useMarkCommentsAsReadMutation$data;
  variables: useMarkCommentsAsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentIds"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "commentIds",
            "variableName": "commentIds"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "MarkCommentsAsReadPayload",
    "kind": "LinkedField",
    "name": "markCommentsAsRead",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "kind": "ScalarField",
        "name": "errors"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useMarkCommentsAsReadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMarkCommentsAsReadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "446a6fa3fbbe8bbb4444e858a1c7626c",
    "id": "2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14",
    "metadata": {},
    "name": "useMarkCommentsAsReadMutation",
    "operationKind": "mutation",
    "text": "mutation useMarkCommentsAsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success,errors}}"
  }
};
})();

(node as any).hash = "d155280f920b93703b5ae452997bdcaf";

export default node;
